import * as React from 'react';
import { useState } from 'react';
import {
  Button,
  Col,
  Container,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  Row,
} from 'reactstrap';
import { resetPasswordToken } from 'src/services';
import { Svg } from '../Svg';

interface IResetPasswordModalProps {
  isOpen: boolean;
  toggleLoginModal: () => void;
  toggleResetPasswordModal: () => void;
}

export const ResetPasswordModal: React.SFC<IResetPasswordModalProps> = ({
  isOpen,
  toggleLoginModal,
  toggleResetPasswordModal,
}) => {
  const [state, setState] = useState({
    email: '',
    invalid: false,
    isSent: false,
  });

  const handleChange = (e: React.ChangeEvent<Element>) => {
    setState({ ...state, email: (e.target as any).value });
  };

  const handleKeyDown = (e: React.KeyboardEvent<Element>) => {
    if (e.key === 'Enter') {
      handleResetPassword();
    }
  };

  const handleResetPassword = async () => {
    try {
      const signupResponse = await resetPasswordToken(state.email);
      if (signupResponse) {
        setState({ email: '', invalid: false, isSent: true });
      }
    } catch (error) {
      if (error && error.response && error.response.status === 404) {
        setState({
          email: '',
          invalid: true,
          isSent: false,
        });
      }
    }
  };

  const closeResetPasswordModal = () => {
    setState({
      email: '',
      invalid: false,
      isSent: false,
    });
    toggleResetPasswordModal();
  };

  const handleLoginClick = () => {
    closeResetPasswordModal();
    toggleLoginModal();
  };

  return (
    <Modal className='position-relative' isOpen={isOpen}>
      <Svg
        className='position-absolute'
        fill='primary'
        width={280}
        height={210}
        opacity={0.1}
        src='bulle-popin'
        style={{ top: '-19px', left: '-15px' }}
      />
      <div className='d-flex justify-content-end p-3'>
        <Svg
          fill='dark'
          src='close'
          width={16}
          onClick={closeResetPasswordModal}
        />
      </div>
      <div className='d-flex justify-content-between align-items-center pl-5 pr-5'>
        <h3>
          Mot de passe
          <br />
          oublié ?
        </h3>
      </div>
      {!state.isSent ? (
        <Container className='p-5' style={{ zIndex: 1 }}>
          <FormGroup>
            <Label>
              Saisissez votre adresse e-mail afin de réinitialiser votre mot de
              passe
            </Label>
            <Input
              type='email'
              name='email'
              placeholder='E-mail*'
              invalid={state.invalid}
              value={state.email}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
            />
            <FormFeedback>Aucun compte n'est associé à cet e-mail</FormFeedback>
          </FormGroup>
          <Row className='d-flex justify-content-end'>
            <Col xs='6'>
              <Button
                className='text-uppercase text-white bg-dark border-0 mt-3'
                onClick={handleLoginClick}
              >
                Retour
              </Button>
            </Col>
            <Col xs='6'>
              <Button
                className='text-uppercase text-white bg-primary float-right border-0 mt-3'
                onClick={handleResetPassword}
              >
                Valider
              </Button>
            </Col>
          </Row>
        </Container>
      ) : (
        <Container className='p-5'>
          <FormGroup>
            <Label>
              Vous allez recevoir dans quelques instants un e-mail pour
              réinitialiser votre mot de passe
            </Label>
          </FormGroup>
        </Container>
      )}
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/shared/Modals/ResetPasswordModal.tsx